"use client";

import React, { useCallback, useEffect, useState } from "react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const memories = [{
  id: 1,
  title: "Sierra Nevada Brewing Company",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/abco_portfolio_sierra_nevada_brewery.jpg",
  year: "",
  location: "Asheville, NC",
  squareFootage: "190,000 sq. ft.",
  scopeOfWork: "Complete mechanical and electrical infrastructure for new brewery operations."
}, {
  id: 2,
  title: "Greensboro Science Center BioDome & ARCC",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/Screenshot 2026-05-17 8.35.39 PM.png",
  year: "",
  location: "Greensboro, NC",
  squareFootage: "",
  scopeOfWork: "in process"
}, {
  id: 3,
  title: "High Point City Lake Park",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/City-Lake-Park-drone-photo_23-0901_036e-scaled-e1753713844993.jpg",
  year: "",
  location: "HIGH POINT, NC",
  squareFootage: "",
  scopeOfWork: ""
}, {
  id: 9,
  title: "Akzo Nobel",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/High-Point2-768x432.png",
  year: "",
  location: "HIGH POINT, NC",
  squareFootage: "",
  scopeOfWork: ""
}, {
  id: 4,
  title: "GlaxoSmithKline",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/abco_portfolio_glaxosmithkline.jpg",
  year: "",
  location: "Research Triangle Park, NC",
  squareFootage: "35,000 sq. ft.",
  scopeOfWork: "ABCO South provided a turnkey electrical installation up fit which included service distribution power, interior, exterior lighting, lighting control and day light harvesting, fire alarm and data raceway for this state of the art office building."
}, {
  id: 6,
  title: "Greensboro Science Center SciQuarium Expansion",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/GSC_outside.jpg",
  year: "",
  location: "Greensboro, NC",
  squareFootage: "",
  scopeOfWork: "ABCO South provided a design build up fit electrical installation which included service distribution power, interior lighting, fire alarm and data raceway for the new medical suite."
}, {
  id: 12,
  title: "GE Aviation Expansion",
  location: "JEFFERSON, NC",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/geaviation-9.jpg",
  year: "",
  squareFootage: "",
  scopeOfWork: ""
}, {
  id: 5,
  title: "MillerCoors Warehouse Addition",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/abco_portfolio_millercoors.png",
  year: "",
  location: "Eden, NC",
  squareFootage: "70,000 sq. ft.",
  scopeOfWork: "ABCO South provided a turnkey electrical installation which included service distribution power, interior, exterior lighting, lighting control, UPS power and data cabling, dock lok power, LGV robot system power and control wiring for this state of the art automated warehouse building."
}, {
  id: 8,
  title: "Balcones Distillery",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/Balcones.png",
  year: "",
  location: "WACO, TEXAS",
  scopeOfWork: "Trinity II is a 3 story office building located near Raleigh's renowned Research Triangle Park. ABCO South installed the shell and up fit lighting, site lighting, lighting control system, power distribution, fire alarm, data raceway, MRI and Infusion suite installations."
}, {
  id: 7,
  title: "USPS Winston Salem EV Charging Stations ( 72 )",
  image: "https://images.unsplash.com/photo-1593941707882-a5bba14938c7?q=80&w=2072&auto=format&fit=crop",
  year: "",
  location: "Winston-Salem, NC",
  squareFootage: "",
  scopeOfWork: "ABCO South provided a ground up electrical installation which included service distribution power, interior ,exterior, theatre lighting, lighting control system and daylight harvesting, fire alarm and data raceway for the new gymnasium, auditorium and classroom building."
}, {
  id: 10,
  title: "Nestle Purina",
  location: "EDEN, NC",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/1__Purina_Eden_grand_opening.jpg",
  year: "",
  squareFootage: "",
  scopeOfWork: ""
}, {
  id: 13,
  title: "High Point University Cottrell Hall",
  location: "HIGH POINT, NC",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/Screenshot 2026-05-29 11.36.12 AM.png",
  year: "",
  squareFootage: "",
  scopeOfWork: ""
}, {
  id: 11,
  title: "Clarios Battery",
  location: "KERNERSVILLE, NC",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/clariosagmproduction1_900xx2126-1196-0-170.jpg",
  year: "",
  squareFootage: "",
  scopeOfWork: ""
}];
export default function HafizalardaKalanlar() {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15
  });
  useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  const scrollTo = useCallback((index: number) => {
    api?.scrollTo(index);
  }, [api]);
  return <section data-section-id="232120" id="project-portfolio" ref={sectionRef} className="bg-background text-foreground pt-12 pb-20 px-4 overflow-hidden relative">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden" aria-hidden="true">
        <span className="font-serif text-foreground/5 font-normal uppercase tracking-widest whitespace-nowrap" style={{
        fontSize: "clamp(4rem, 12vw, 10rem)"
      }}>
          PROJECTS
        </span>
      </div>

      {}
      <div className={`relative z-10 flex justify-center mb-16 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="px-10 py-4 rounded-md text-white font-serif text-sm md:text-base uppercase tracking-widest shadow-sm text-center w-full" style={{
        backgroundColor: "var(--secondary)"
      }}>At ABCO South, safety is not just a priority—it is part of our culture. We expect every team member, from leadership to field personnel, to take ownership of maintaining a safe and compliant work environment on every project.</div>
      </div>

      {}
      <div className={`relative z-10 text-center mb-14 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="inline-block w-12 h-0.5 mb-4" style={{
        backgroundColor: "var(--primary)"
      }} />
        <h2 className="font-serif text-5xl md:text-6xl font-normal uppercase tracking-widest text-foreground">
          Portfolio
        </h2>
        <div className="inline-block w-12 h-0.5 mt-4" style={{
        backgroundColor: "var(--primary)"
      }} />
      </div>

      {}
      <div className={`relative z-10 max-w-6xl mx-auto transition-all duration-900 delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <Carousel setApi={setApi} opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent className="-ml-4">
            {memories.map((memory, i) => <CarouselItem key={memory.id} data-index={i} className="pl-4 basis-full sm:basis-1/2 lg:basis-1/3">
                <div className="relative group overflow-hidden rounded-md aspect-[3/4] cursor-pointer border border-border">
                  {}
                  <img src={memory.image} data-wvc-srcset={memory.image.startsWith('artifact_') ? `${memory.image}-wvc-srcset` : `${memory.image}-wvc-srcset`} data-wvc-sizes={memory.image.startsWith('artifact_') ? `${memory.image}-wvc-sizes` : `${memory.image}-wvc-sizes`} alt={memory.title} loading="lazy" className="w-full h-full object-cover grayscale transition-all duration-500 group-hover:grayscale-0 group-hover:scale-105" />

                  {}
                  <div className="absolute inset-0 transition-opacity duration-500 opacity-40 group-hover:opacity-0" style={{
                backgroundColor: "var(--foreground)"
              }} />

                  {}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />

                  {}
                  <div className={`absolute bottom-0 left-0 right-0 p-5 transform ${memory.id === 3 ? "translate-y-0" : "translate-y-1"} group-hover:translate-y-0 transition-transform duration-500`}>
                    {memory.year && <p className="font-default text-[10px] uppercase tracking-widest text-white/80 mb-0.5">
                        Year: {memory.year}
                      </p>}
                    {memory.location && <p className="font-default text-[10px] uppercase tracking-widest text-white/80 mb-0.5">
                        Location: {memory.location}
                      </p>}
                    {memory.squareFootage && <p className="font-default text-[10px] uppercase tracking-widest text-white/80 mb-1">
                        Size: {memory.squareFootage}
                      </p>}
                    <h3 className="font-serif text-base md:text-lg font-semibold text-white leading-snug">
                      {memory.title}
                    </h3>
                    <div className="mt-2 w-8 h-0.5 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" style={{
                  backgroundColor: "var(--primary)"
                }} />
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
        </Carousel>

        {}
        <div className="flex items-center justify-center gap-3 mt-10">
          {Array.from({
          length: count
        }).map((_, i) => <button key={i} data-index={i} onClick={() => scrollTo(i)} aria-label={`Slide ${i + 1}`} className={`transition-all duration-300 rounded-lg border-none outline-none cursor-pointer ${i === current ? "w-6 h-2" : "w-2 h-2 opacity-40 hover:opacity-70"}`} style={{
          backgroundColor: i === current ? "var(--primary)" : "var(--foreground)",
          boxShadow: i === current ? `0 0 8px 1px var(--primary)` : "none"
        }} />)}
        </div>
      </div>
    </section>;
}